import { createSearchCacheContext } from './search-cache-context';
import { ISummaryItem } from '../../services/summaries/summary.service';
import { IYouTubeVideoResult } from '../summaries/youtube-summary-item-list';
import { IViatorProduct } from '../../Models/viator/viator.model';

/**
 * AI Summaries Cache
 * Caches AI-powered place search results (restaurants, hotels, activities, etc.)
 * Max 20 entries with LRU eviction
 */
export const { Provider: AISearchCacheProvider, useCache: useAISearchCache } =
  createSearchCacheContext<ISummaryItem>('ai_summaries', 20);

/**
 * YouTube Videos Cache
 * Caches YouTube video search results for destinations
 * Max 20 entries with LRU eviction
 */
export const {
  Provider: YouTubeSearchCacheProvider,
  useCache: useYouTubeSearchCache
} = createSearchCacheContext<IYouTubeVideoResult>('youtube_videos', 20);

/**
 * Viator Tours Cache
 * Caches Viator tour search results
 * Max 20 entries with LRU eviction
 */
export const {
  Provider: ViatorSearchCacheProvider,
  useCache: useViatorSearchCache
} = createSearchCacheContext<IViatorProduct>('viator_tours', 20);

/**
 * Future: Web Results Cache
 * Uncomment when web search integration is implemented
 */
// import { IWebResult } from '../../services/search/web-search.service';
// export const {
//   Provider: WebSearchCacheProvider,
//   useCache: useWebSearchCache
// } = createSearchCacheContext<IWebResult>('web_results', 20);
